import * as React from "react";
import AppConfig from "../AppConfig";
const HideOnCloud = ({ children, ...rest }) => {
  if (AppConfig.isCloud()) {
    return null;
  }
  return React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, rest);
    }
    return child;
  });
};
export default HideOnCloud;
